/* eslint-disable consistent-return */
import { useCallback, useState } from "react";
// eslint-disable-next-line import/no-unresolved
import { callApi, callApiIO } from "@src/api";
// import { useAuth } from "@src/hooks/useAuth";

import { toast } from "react-toastify";
import _, { isString } from "lodash";
// import axios from "axios";
import { useAuth } from "../useAuth";
import { REPORT_TYPES } from "../../views/MyReports/const";
import { parseJSON } from "../../utility/CustomFunction";

const LOADING_TYPES = {
  FETCH_SETTINGS: "fetch",
  FETCH_TXN_DATA: "fetchTxnData",
  FETCH_PIVOT_REPORTS: "fetchPivotReports",
  COPY_REPORT: "copyReport",
  DELETE_REPORT: "deletReport",
  UPDATE_SETTINGS: "updateSettings",
  FETCH_REPORT_PARAMS: "fetchReportParams",
  FETCH_APPT_DATA: "fetchApptData",
  ADD_NEW_PIVOT_REPORT: "addNewPivotReport",
  UPDATE_PIVOT_REPORT: "updatePivotReport",
};

const REPORT_DELETION_METADATA = "reportdeletionmetadata";

function onlyUnique(value, index, self) {
  return self.indexOf(value) === index;
}

const getColumnType = (x) => {
  if (["created_at", "updated_at", "deleted_at"]?.includes(x.name)) {
    return "datetime";
  }
  if (x.base_type?.toLowerCase().indexOf("datetime") !== -1) {
    return "datetime";
  }
  if (x.base_type?.toLowerCase().indexOf("date") !== -1) {
    return "datetime";
  }
  switch (x.base_type) {
    case "type/Number":
    case "type/Float":
      return "number";
    default:
      return "string";
  }
};

const getFormat = (x) => {
  const colType = getColumnType(x);
  if (colType === "date") return "YYYY/MM/DD";
  if (colType === "datetime") return "YYYY/MM/DD HH:mm:ss";
  return undefined;
};

const getTransformType = (x) => {
  const colType = getColumnType(x);
  if (colType === "datetime") return "utcDatetimeToLocal";
  return undefined;
};

const useCustomData = () => {
  const [customQueryData, setCustomQueryData] = useState(null);
  const { selectedBusiness, user } = useAuth();

  const [loading, setLoading] = useState(false);

  const getCardDetails = async (cardId) => {
    const res = await callApiIO(
      `/protected/business/${selectedBusiness?.id
      }/iorequest?dest=${encodeURIComponent(`business/:BID:/reports/metabase/card/${cardId}`)}`
    );
    if (!res?.status) {
      toast.error("Failed to fetch card details");
    }
    return res;
  };

  const runMetabaseQuery = async (cardId, payload) => {
    setLoading(true);
    // const config = {
    //   method: "POST",
    //   url: `https://bi.growthzilla.com/api/card/${cardId}/query/json`,
    //   withCredentials: true,
    //   headers: {
    //     "Content-Type": "application/json",
    //     "X-Metabase-Session": "d93b49dd-15bf-4ba7-b201-cb006a874606",
    //   },
    //   params: { parameters: JSON.stringify(payload.parameters) },
    // };

    // await axios(config).catch((err) => {
    //   console.log({err});
    // });
    const res = await callApiIO(
      `/protected/business/${selectedBusiness?.id
      }/iorequest?dest=${encodeURIComponent(
        `business/:BID:/reports/metabase/card/${cardId}/query`
      )}`,
      "POST",
      {
        payload: {
          collection_preview: false,
          ignore_cache: false,
          // database: 3,
          ...payload,
        },
      },
      null
    );
    setLoading(false);
    return res;
  };

  const runMetabaseQueryJSON = async (cardId, payload) => {
    setLoading(true);
    const res = await callApiIO(
      `/protected/business/${selectedBusiness?.id
      }/iorequest?dest=${encodeURIComponent(
        `business/:BID:/reports/metabase/card/${cardId}/query/json`
      )}`,
      "POST",
      {
        payload: {
          collection_preview: false,
          ignore_cache: false,
          // database: 3,
          ...payload,
        },
      },
      null
    );
    setLoading(false);
    return res;
  };

  const getParameterValue = (parameter, period) => {
    switch (parameter.config?.valueType) {
      case ":BID:":
        return selectedBusiness?.id;
      case ":NID:":
        return selectedBusiness?.network_id;
      case ":UID:":
        return user?.id;
      case ":PERIOD-START:":
        return period?.start;
      case ":PERIOD-END:":
        return period?.end;
      case ":PERIOD:":
        return `${period.start}~${period.end}`;
      default:
        return parameter.config?.value;
    }
  };

  const getCustomQueryData = async ({
    dataSource,
    start,
    end,
    force,
    resultMetadata,
  }) => {
    try {
      if (!force) {
        if (
          customQueryData?.start === start &&
          customQueryData?.end === end &&
          customQueryData?.id === dataSource?.id &&
          customQueryData?.updated_at === dataSource?.updated_at &&
          customQueryData?.business_id === selectedBusiness?.id
        )
          return { status: true };
      }
      const temp = {
        id: dataSource?.id,
        updated_at: dataSource?.updated_at,
        business_id: selectedBusiness?.id,
        start,
        end,
      };

      const parameters = dataSource.settings?.parameters?.map((el) => ({
        id: el.id,
        type: el.type,
        target: el.target,
        value: getParameterValue(el, { start, end }),
      }));

      // metabase new fetch method
      if (resultMetadata) {
        const res = await runMetabaseQueryJSON(dataSource?.metabase_id, {
          parameters,
        });
        if (res?.status) {
          const result = res.data || [];

          const formattedCols = resultMetadata?.map?.((el) => ({
            id: el.name,
            dataType: getColumnType(el),
            label: el.display_name,
            type: "Custom",
            format: getFormat(el),
            transform: getTransformType(el),
          }));

          setCustomQueryData({
            ...temp,
            response: res.data,
            data: result,
            columns: formattedCols,
          });
          return res;
        }
        throw new Error("failed to fetch data");
      }

      const res = await runMetabaseQuery(dataSource?.metabase_id, {
        parameters,
      });

      if (res?.status) {
        const result = res.data?.data;
        if (!temp) throw new Error("Failed to Generate Report");
        const { rows, cols } = result;
        const formattedRows = rows.map((x) => {
          const tem = {};
          cols.forEach((col, i) => {
            if (!rows || !cols) throw new Error("Failed to Generate Report");
            tem[col.name] = x[i];
          });
          return tem;
        });

        const formattedCols = cols.map((el) => ({
          id: el.name,
          dataType: getColumnType(el),
          label: el.display_name,
          type: "Custom",
          format: getFormat(el),
          transform: getTransformType(el),
        }));

        setCustomQueryData({
          ...temp,
          response: res.data,
          data: formattedRows,
          columns: formattedCols,
        });
      } else {
        throw new Error("failed to fetch data");
      }
      return res;
    } catch (e) {
      toast.error("Failed to fetch data");
      return { status: false, message: e.message };
    }
  };

  const formatDataSourceColumns = (columns) => {
    return columns?.map((el) => ({
      id: el.name,
      dataType: getColumnType(el),
      label: el.display_name,
      type: "Custom",
      format: getFormat(el),
      transform: getTransformType(el),
    }));
  };

  return {
    customQueryData,
    setCustomQueryData,
    getCustomQueryData,
    formatDataSourceColumns,
    loading,
    getCardDetails,
  };
};

// const filterMetabaseCards = (arr) =>
//   arr?.filter((el) => el.database_id === (isProduction ? 2 : 3));

export default (userAcl) => {
  const {
    selectedBusiness,
    business,
    user,
    // runWithGuard,
  } = useAuth();
  const [salesDetailForTransactions, setSalesDetailForTransactions] =
    useState(null);
  const [apptDataForReports, setApptDataForReports] = useState(null);
  const {
    customQueryData,
    setCustomQueryData,
    getCustomQueryData,
    formatDataSourceColumns,
    loading: loadingCustomQuery,
    getCardDetails,
  } = useCustomData();

  const [addedSubFields, setAddedSubFields] = useState([]);

  const [customReportGallery, setCustomReportGallery] = useState();
  const [cubeReports, setCubeReports] = useState(null);
  const [metabaseCards, setMetabaseCards] = useState(null);
  const [customDataSources, setCustomDataSources] = useState(null);

  const getMetabaseCards = async () => {
    const res = await callApiIO(
      `/protected/business/${selectedBusiness?.id
      }/iorequest?dest=${encodeURIComponent(`business/:BID:/reports/metabase/card`)}`
    );
    if (res?.status) {
      setMetabaseCards(res.data);
    } else {
      toast.error("Failed to fetch metabase cards");
    }
    return res;
  };

  const getMetabaseDashboardParams = async (dashboardId) => {
    const res = await callApiIO(
      `/protected/business/${selectedBusiness?.id
      }/iorequest?dest=${encodeURIComponent(`business/:BID:/reports/metabase/dashboard/${dashboardId}`)}`
    );
    if (!res?.status) {
      toast.error("Failed to fetch metabase dashboard params");
      return null;
    }
    // const { parameters } = res.data;
    if (res?.data?.parameters) return res.data.parameters;

    toast.error("Failed to fetch metabase dashboard params");
    return null;

  };

  const getCustomDataSources = async () => {
    const res = await callApiIO(
      `/protected/business/${selectedBusiness?.id
      }/iorequest?dest=${encodeURIComponent(`business/:BID:/reports/datasources/get`)}`
    );
    if (res.status) {
      setCustomDataSources(res.data);
    } else setCustomDataSources(undefined);
    return res;
  };

  const updateDataSourceCache = (data) => {
    const newData = {
      ...data,
      settings:
        data.settings !== undefined
          ? parseJSON(data.settings, true)
          : undefined,
    };
    setCustomDataSources(
      customDataSources?.map?.((el) =>
        el.id === data?.id ? { ...el, ...newData } : el
      )
    );
  };

  const addCustomDataSource = async (data) => {
    // name, description, source, metabase_id, settings
    const res = await callApiIO(
      `/protected/business/${selectedBusiness?.id
      }/iorequest?dest=${encodeURIComponent(`business/:BID:/reports/datasources/add`)}`,
      "POST",
      data
    );
    if (res.status) {
      toast.success("Successfully added data source");
      getCustomDataSources();
    } else {
      toast.error("Failed to add data source");
    }
    return res;
  };

  const removeCustomDataSource = async (sid) => {
    const res = await callApiIO(
      `/protected/business/${selectedBusiness?.id
      }/iorequest?dest=${encodeURIComponent(
        `business/:BID:/reports/datasources/${sid}/delete`
      )}`,
      "POST"
    );
    if (res.status) {
      toast.success("Data source deleted successfully");
      setCustomDataSources(customDataSources?.filter((el) => el.id !== sid));
    } else {
      toast.error("Failed to delete data source");
    }
    return res;
  };

  const updateCustomDataSource = async (sid, data) => {
    const res = await callApiIO(
      `/protected/business/${selectedBusiness?.id
      }/iorequest?dest=${encodeURIComponent(
        `business/:BID:/reports/datasources/${sid}/update`
      )}`,
      "POST",
      data
    );
    if (res.status) {
      const newSource = res.data;
      updateDataSourceCache(newSource);
    }
    return res;
  };

  const searchSubField = (x) => addedSubFields?.includes(x);

  const addSubField = (x) => {
    const res = searchSubField(x);
    if (!res) {
      addedSubFields.push(x);
      setAddedSubFields([...addedSubFields, x].filter(onlyUnique));
    }
    return !res;
  };

  const aclRules = userAcl?.aclRules;

  const [pivotReports, setPivotReports] = useState(null);

  const [deleteMetadata, setDeleteMetadata] = useState(null);

  const [periodReport, setPeriodReport] = useState(null);

  const [reportSettings, setReportSettings] = useState(null);
  const [overriddenSettings, setOverriddenSettings] = useState(null);
  const [reportParams, setReportParams] = useState(null);
  const [loading, setLoading] = useState(null);

  const getFormattedSettings = useCallback(() => {
    const reportsFromSettings = overriddenSettings?.configuration || [];
    const formatted = reportSettings?.map((r) => {
      const overridden = _.find(
        reportsFromSettings,
        (e) => e.id === r.id && e.type === REPORT_TYPES.PROC
      );
      return { ...r, ...(overridden || {}), reportType: r.type };
      // let updated = { ...r };
      // categories?.forEach((c) => {
      //   if (c.reportIds.includes(r.id)) {
      //     updated = {
      //       ...r,
      //       category_name: c.categoryName,
      //       category_icon: c.categoryIcon,
      //     };
      //   }
      // });
      // return updated;
    });
    return formatted;
  }, [reportSettings, overriddenSettings]);

  const getFormattedPivotReports = useCallback(() => {
    const reportsFromSettings = overriddenSettings?.configuration || [];
    const formatted = pivotReports?.map((r) => {
      const overridden = _.find(
        reportsFromSettings,
        (e) => e.id === r.id && e.type === REPORT_TYPES.PIVOT
      );
      return { ...r, ...(overridden || {}) };
    });
    return formatted;
  }, [pivotReports, overriddenSettings]);

  const getFormattedCubeReports = useCallback(() => {
    const reportsFromSettings = overriddenSettings?.configuration || [];
    const formatted = cubeReports?.map((r) => {
      const overridden = _.find(
        reportsFromSettings,
        (e) => e.id === r.id && e.type === REPORT_TYPES.CUBE
      );
      return { ...r, ...(overridden || {}) };
    });
    return formatted;
  }, [cubeReports, overriddenSettings]);

  const id = selectedBusiness?.id;

  const getSalesDetailForTransactions = async (startDate, endDate) => {
    setLoading(LOADING_TYPES.FETCH_TXN_DATA);
    setSalesDetailForTransactions(null);
    const response = await callApi(
      `/protected/business/${id}/custom/proc/GetSalesDetailForTransactions/run?params=%22${startDate}%22%2C%22${endDate}%22&start=${startDate}&end=${endDate}`
    );
    if (response && response.status === true) {
      setSalesDetailForTransactions({
        data: response.data,
        startDate,
        endDate,
      });
    } else {
      // console.log({ response });
      toast.error("Failed to get transactions data");
    }
    setLoading(null);
    return response.data
  };

  const getAppointmentDataForReports = async (startDate, endDate) => {
    setLoading(LOADING_TYPES.FETCH_APPT_DATA);
    const response = await callApi(
      `/protected/business/${id}/custom/proc/GetAppointmentsForBusinessInServicePeriod/run?params=%22${startDate}%22%2C%22${endDate}%22&start=${startDate}&end=${endDate}`
    );
    if (response && response.status === true) {
      setApptDataForReports({
        data: response.data,
        startDate,
        endDate,
      });
    } else {
      // console.log({ response });
      toast.error("Failed to get appointment data");
    }
    setLoading(null);
  };

  const getPivotReports = async () => {
    setLoading(LOADING_TYPES.FETCH_PIVOT_REPORTS);
    const response = await callApi(
      `/protected/business/${id}/pivotreports/new?withdeleted=1`
    );
    if (response && response.status === true) {
      setPivotReports(response.data);
    } else {
      toast.error(response?.message || "Failed to fetch pivot reports");
    }
    setLoading(null);
  };

  const getPeriodReports = async (startDate, endDate) => {
    setPeriodReport(null);
    const response = await callApi(
      `/protected/business/${id}/periodreport/${startDate}/${endDate}?detail=true`
    );
    if (response && response.status === true) {
      setPeriodReport(response.data);
      return response.data;
    }
  };

  const getDeleteMetaData = async () => {
    const res = await callApi(
      `/protected/business/${id}/tablesettings/${REPORT_DELETION_METADATA}/get`
    );
    if (res?.status) {
      setDeleteMetadata(res.data);
    }
    return res;
  };

  const updateDeleteMetaData = async (updateData) => {
    const res = await callApi(
      `/protected/business/${id}/tablesettings/${REPORT_DELETION_METADATA}/update`,
      "POST",
      { settings: updateData }
    );
    if (res?.status) {
      setDeleteMetadata(res.data);
    }
    return res;
  };

  const fetchCustomReports = async () => {
    const res = await callApi(
      `/protected/business/${id}/customreports/all?withdeleted=1`
    );
    if (res && res.status === true) {
      const hasCustomReportPermissions =
        aclRules?.includes("unrestricted") ||
        aclRules?.includes("reporting.customreport");
      if (!hasCustomReportPermissions) {
        setReportSettings([]);
      } else if (aclRules?.includes("unrestricted")) {
        setReportSettings(res.data);
      } else {
        const allowedReports = user?.acl?.custom || [];
        setReportSettings(
          res.data.filter(
            (x) =>
              allowedReports?.includes(x.id) ||
              (x.legacy_id &&
                allowedReports?.includes(`${id}${x.legacy_id}`)) ||
              x.created_by === user?.id
          )
        );
      }
    } else {
      toast.error("Failed to fetch custom reports");
      setReportSettings([]);
    }
  };

  const getReportSettings = async () => {
    setLoading(LOADING_TYPES.FETCH_SETTINGS);
    const res = await callApi(
      `/protected/business/${id}/customreports/all?withdeleted=1`
    );
    // console.log({ "response 1": JSON.stringify(res) });
    const res2 = await callApi(
      `/protected/business/${id}/tablesettings/customreports/get`
    );
    // console.log({ "response 2": JSON.stringify(res2) })
    const res3 = await callApiIO(
      `/protected/business/${selectedBusiness.id}/iorequest?dest=${encodeURIComponent(
        `customcubereports/business/:BID:/gallery/get`
      )}`,
      "GET",
    );
    // console.log({ "response 3": res3 });
    if (res && res.status === true) {
      const hasCustomReportPermissions =
        aclRules?.includes("unrestricted") ||
        aclRules?.includes("reporting.customreport");
      if (!hasCustomReportPermissions) {
        setReportSettings([]);
      } else if (aclRules?.includes("unrestricted")) {
        setReportSettings(res.data);
      } else {
        const allowedReports = user?.acl?.custom || [];
        setReportSettings(
          res.data.filter(
            (x) =>
              allowedReports?.includes(x.id) ||
              (x.legacy_id &&
                allowedReports?.includes(`${id}${x.legacy_id}`)) ||
              x.created_by === user?.id
          )
        );
      }
    } else {
      toast.error("Failed to fetch custom reports");
      setReportSettings([]);
    }
    if (res2 && res2.status === true) {
      setOverriddenSettings(res2.data);
    } else {
      toast.error("Failed to fetch custom report settings");
    }
    if (res3 && res3.status === true) {
      setCubeReports(res3.data);
    } else {
      toast.error("Failed to fetch custom report settings");
    }
    setLoading(null);
  };

  const reportVersionConverter = (report) => {
    const newReport = {};
    newReport.title = report.title;
    newReport.description = report.description || report.subtitle || "";
    newReport.category_name = "";
    const type = report.embed
      ? "embed"
      : report.fromProcedure
        ? "procedure"
        : "function";
    const procedureType = report.fromProcedure?.name
      ? !Number.isNaN(+report.fromProcedure.name.substr?.(0, 1))
        ? 0
        : 1
      : 1;
    newReport.report_level = report.reportLevel || null;
    newReport.report_layout = report.reportLayout || null;
    newReport.add_columns_before = report.addColumnsBefore ? 1 : 0;
    newReport.type = type;
    newReport.generic = procedureType;
    newReport.name =
      report?.fromProcedure?.name || report?.fromFunction?.name || null;
    newReport.params =
      report?.fromProcedure?.params || report?.fromFunction?.params || null;
    newReport.settings =
      report?.fromProcedure || report?.fromFunction || report?.embed || null;
    newReport.columns = report?.columns || null;
    return newReport;
  };

  const handleImportReport = async (report) => {
    const newReport = reportVersionConverter(report);
    // const payload = Object.keys(newReport).map((x) => ({
    //   key: x,
    //   value: newReport[x],
    // }));

    // const payload = Object.keys(newReport).map((x) => ({ [x]: newReport[x] }));

    // const payload = [newReport];

    const payload = newReport;

    const res = await callApi(
      `/protected/business/${selectedBusiness.id}/customreports/new`,
      "POST",
      payload
    );
    if (res.status) {
      setReportSettings([...(reportSettings || []), res.data]);
    }
    return res;
  };

  const addEmbedReport = async (data) => {
    try {
      const res = await callApi(
        `/protected/business/${selectedBusiness.id}/customreports/new`,
        "POST",
        {
          title: data?.title,
          description: data?.description || "",
          category_name: "",
          type: "embed",
          report_level: null,
          report_layout: null,
          add_columns_before: 0,
          generic: 1,
          name: null,
          params: null,
          settings: { ...data?.settings },
          columns: [],
        }
      );
      if (res.status) {
        setReportSettings([...(reportSettings || []), res.data]);
      }
      return res;
    } catch {
      toast.error("Failed to add report");
      return { status: false };
    }
  };

  const getSelectedBusinessDetails = () => business.find((b) => b.id === id);

  const getCustomReports = () => {
    const reportsettings =
      getSelectedBusinessDetails()?.business?.reportsettings;
    // const { reportsettings } = getSelectedBusinessDetails().business;
    return reportsettings && reportsettings.enabled
      ? reportsettings.reports
      : [];
  };

  const copyReport = async (reportId, businessIds, params) => {
    setLoading(LOADING_TYPES.COPY_REPORT);

    const modifiedParams = isString(params)
      ? params
        .replace(/("business.?id"):.+?(?=[,}])/g, '$1:":BID:"')
        .replace(/("network.?id"):.+?(?=[,}])/g, '$1:":NID:"')
      : params;

    const res = await callApi(
      `/protected/business/${id}/customreport/${reportId}/duplicate`,
      "POST",
      {
        locations: businessIds,
        params: parseJSON(modifiedParams),
      }
    );
    if (res && res.status === true) {
      toast.success(
        `Report added to ${businessIds?.length} business${businessIds?.length ? "es" : ""
        }`
      );
      // getReportSettings();
    } else {
      toast.error(res.message || "Failed to copy custom report");
    }
    setLoading(null);
  };

  const copyReportPivot = async ({
    businessIds,
    title,
    description,
    config,
  }) => {
    setLoading(LOADING_TYPES.COPY_REPORT);

    const res = await callApi(
      `/protected/business/${id}/pivotreport/new/add`,
      "POST",
      {
        bids: businessIds,
        report: {
          configuration: config,
          title,
          description,
          type: "new",
        },
      }
    );

    if (res && res.status === true) {
      toast.success(
        `Report added to ${businessIds?.length} business${businessIds?.length ? "es" : ""
        }`
      );
      // getReportSettings();
    } else {
      toast.error(res.message || "Failed to copy report");
    }
    setLoading(null);
  };

  const deleteReport = async (reportId, type, deletedAt) => {
    setLoading(LOADING_TYPES.DELETE_REPORT);
    let res;
    if (type === REPORT_TYPES.PIVOT) {
      res = await callApi(
        `/protected/business/${selectedBusiness?.id
        }/iorequest?dest=${encodeURIComponent(
          `reports/business/:BID:/report/${reportId}/deletereport`
        )}`,
        "POST",
        { type: "pivot", deleted_at: deletedAt }
      );
      if (res && res.status === true) {
        if (deletedAt === null) toast.success(`Successfully restored`);
        else if (deletedAt === undefined) toast.success(`Successfully deleted`);
        else toast.success("Report marked for deletion");
        getPivotReports();
      } else {
        toast.error(res.message || "Request failed");
      }
      setLoading(null);
    } else {
      res = await callApi(
        `/protected/business/${selectedBusiness?.id
        }/iorequest?dest=${encodeURIComponent(
          `reports/business/:BID:/report/${reportId}/deletereport`
        )}`,
        "POST",
        { type: "custom", deleted_at: deletedAt }
      );
      if (res && res.status === true) {
        if (deletedAt === null) toast.success(`Successfully restored`);
        else if (deletedAt === undefined) toast.success(`Successfully deleted`);
        else toast.success("Report marked for deletion");
        getReportSettings();
      } else {
        toast.error(res.message || "Request failed");
      }
      setLoading(null);
    }
    if (res?.status) {
      const temp = await getDeleteMetaData();
      if (!temp?.status) return;
      const configs = temp?.data?.configuration || [];
      const newConfigs = [
        ...(configs?.filter?.(
          (el) => el.report_id !== reportId || el.type !== type
        ) || []),
        ...(deletedAt !== null
          ? [
            {
              report_id: reportId,
              type,
              deletedBy: {
                id: user?.id,
                name: user?.fullname,
                email: user?.email,
                username: user?.username,
              },
            },
          ]
          : []),
      ];
      await updateDeleteMetaData({
        configuration: newConfigs,
        title: "Report Deletion Metadata",
        id: temp?.data?.id,
      });
    }
  };

  const updateSetting = async (obj, noToast) => {
    setLoading(LOADING_TYPES.UPDATE_SETTINGS);
    const res = await callApi(
      `/protected/business/${id}/tablesettings/customreports/update`,
      "POST",
      obj
    );
    if (res && res.status === true) {
      if (!noToast) toast.success("Successfully added");
      setOverriddenSettings(res.data);
    } else if (!noToast) toast.error(`Failed to add`);
    setLoading(null);
  };

  const updateCustomReport = async (cid, data) => {
    const res = await callApi(
      `/protected/business/${selectedBusiness?.id}/customreports/${cid}/update`,
      "POST",
      data
    );
    if (res?.status) {
      toast.success("Report Updated Successfully");
      setReportSettings(
        reportSettings?.map((x) => {
          if (x.id === cid) return res.data;
          return x;
        })
      );
    } else {
      toast.error(res?.message || "Failed to update report");
    }
    return res;
  };

  const editPivotReport = async (cid, data) => {
    const res = await callApi(
      `/protected/business/${selectedBusiness?.id}/pivotreport/new/update`,
      "POST",
      {
        id: cid,
        report: data,
      }
    );
    if (res?.status) {
      toast.success("Report Updated Successfully");
      setPivotReports(
        pivotReports?.map((x) => {
          if (x.id === res.data?.id) return res.data;
          return x;
        })
      );
    } else {
      toast.error(res?.message || "Failed to update report");
    }
    return res;
  };

  const updatePivotReportConfiguration = async (cid, data) => {
    const res = await callApi(
      `/protected/business/${selectedBusiness?.id}/pivotreport/new/update`,
      "POST",
      {
        id: cid,
        report: {
          configuration: data?.configuration,
          title: data?.title,
          description: data?.description,
          id: cid,
        },
      }
    );
    if (res?.status) {
      // const found = _.find(pivotReports, { id: cid });
      // if (found) {
      //   found.configuration = res.data?.configuration;
      // }
      setPivotReports(
        pivotReports?.map((x) => {
          if (x.id === res.data?.id) return res.data;
          return x;
        })
      );
    } else {
      toast.error(res?.message || "Failed to update report settings");
    }
    return res;
  };

  const addCategory = async (name, icon, reports, noToast) => {
    if (
      overriddenSettings?.configuration?.find((c) => c.category_name === name)
    ) {
      toast.error(`Category ${name} already exists`);
      return;
    }
    const newObj = {
      settings: {
        title: "Custom Report Settings",
        id: overriddenSettings?.id || undefined,
        configuration: [
          ...(overriddenSettings?.configuration?.filter(
            (c) => !_.find(reports, (r) => r.id === c.id && r.type === c.type)
            // (c) => !(reports.includes(c.id) && c.type === type)
          ) || []),
          ...reports.map((e) => ({
            id: e.id,
            category_name: name,
            category_icon: icon,
            type: e.type,
          })),
        ],
      },
    };
    await updateSetting(newObj, noToast);
  };

  const updateCategory = async (oldName, newName, newIcon, noToast) => {
    // console.log("REPORT IDS", reportIds);
    const newObj = {
      settings: {
        title: "Custom Report Settings",
        id: overriddenSettings?.id || undefined,
        configuration: [
          ...overriddenSettings?.configuration?.map((e) => {
            // if (reportIds.includes(e.id)) {
            //   return { ...e, category_name: newName, category_icon: newIcon };
            // }
            if (e.category_name === oldName) {
              return { ...e, category_name: newName, category_icon: newIcon };
            }
            return e;
          }),
        ],
      },
    };
    await updateSetting(newObj, noToast);
  };

  const changeCategoryOfAReport = async (report, categoryName) => {
    const cat = categoryName
      ? overriddenSettings?.configuration.find(
        (c) => c.category_name === categoryName
      )
      : null;
    const _hasCategory = overriddenSettings?.configuration.find(
      (c) => c.id === report.id && c.type === report.type
    );

    const newObj = {
      settings: {
        title: "Custom Report Settings",
        id: overriddenSettings?.id || undefined,
        configuration: _hasCategory
          ? [
            ...overriddenSettings?.configuration
              ?.map((e) => {
                if (e.id === report.id && e.type === report.type) {
                  return cat
                    ? {
                      ...e,
                      category_name: cat?.category_name,
                      category_icon: cat?.category_icon,
                    }
                    : undefined;
                }
                return e;
              })
              .filter((r) => r !== undefined),
          ]
          : [
            ...overriddenSettings?.configuration,
            cat
              ? {
                id: report.id,
                category_name: cat?.category_name,
                category_icon: cat?.category_icon,
                type: report.type,
              }
              : undefined,
          ].filter((r) => r !== undefined),
      },
    };
    await updateSetting(newObj);
  };

  const getReportParams = async () => {
    setLoading(LOADING_TYPES.FETCH_REPORT_PARAMS);
    // const res = await callApi(`/protected/business/${id}/reportparams/all`);
    const res = await callApi(
      `/protected/business/${selectedBusiness?.id
      }/iorequest?dest=${encodeURIComponent(`business/:BID:/systemsettings/uzeli-dashboard-report-params`)}`
    );
    if (res && res.success) {
      const repParams = parseJSON(res?.data[0]?.configurations);
      if (repParams) setReportParams(repParams);
    } else {
      toast.error(res.message || "Failed to fetch report params");
    }
    setLoading(null);
  };

  const addNewPivotReport = async ({
    title,
    description,
    config,
    onSuccess,
    selectedCategoryName,
    newCategoryTitle,
    newCategoryIcon,
  }) => {
    setLoading(LOADING_TYPES.ADD_NEW_PIVOT_REPORT);
    const res = await callApi(
      `/protected/business/${id}/pivotreport/new/add`,
      "POST",
      {
        business_id: selectedBusiness.id,
        report: {
          configuration: config,
          title,
          description,
          type: "new",
        },
      }
    );
    if (res && res.status) {
      const newReport = { id: res.data.id, type: REPORT_TYPES.PIVOT };
      if (newCategoryTitle) {
        await addCategory(newCategoryTitle, newCategoryIcon, [newReport], true);
      } else if (selectedCategoryName) {
        await changeCategoryOfAReport(newReport, selectedCategoryName, true);
      }
      getPivotReports();
      onSuccess();
      toast.success("Successfully added");
    } else {
      toast.error(res.message || "Failed to save");
    }
    setLoading(null);
  };

  const updatePivotReport = async ({
    initialData,
    title,
    description,
    type,
    config,
  }) => {
    setLoading(LOADING_TYPES.ADD_NEW_PIVOT_REPORT);
    const res = await callApi(
      `/protected/business/${id}/pivotreport/new/update`,
      "POST",
      {
        ...initialData,
        report: {
          ...initialData.report,
          configuration: config,
          title,
          type,
          description,
        },
      }
    );
    if (res && res.status) {
      toast.success(`Successfully updated`);
      getPivotReports();
    } else {
      toast.error(res.message || "Failed to update");
    }
    setLoading(null);
  };

  const filterUniqueReports = (data) => {
    return data?.filter((report, index, self) => {
      return (
        index ===
        self.findIndex(
          (el) => el.title === report.title && el.type === report.type
        )
      );
    });
  };

  const fetchCustomReportGallery = async () => {
    const res = await callApi(
      `/protected/business/${selectedBusiness?.id
      }/iorequest?dest=${encodeURIComponent(
        "customreports/business/:BID:/gallery/get"
      )}`
    );
    if (res?.status) {
      setCustomReportGallery(res.data);
    }
  };

  const makeReportPublic = async (rid, data) => {
    const res = await callApi(
      `/protected/business/${selectedBusiness?.id
      }/iorequest?dest=${encodeURIComponent(
        `customreports/business/:BID:/report/${rid}/makepublic`
      )}`,
      "POST",
      data
    );
    if (res?.status) {
      if (customReportGallery?.length) {
        const resData = {
          ...res.data,
          settings: parseJSON(res.data?.settings),
          params: parseJSON(res.data?.params),
          columns: parseJSON(res.data?.columns),
        };
        setCustomReportGallery(
          filterUniqueReports([...(customReportGallery || []), resData])
        );
        setReportSettings(
          reportSettings?.map((x) =>
            x.id === rid
              ? {
                ...x,
                settings: data.settings ?? x.settings,
                description: data.description ?? x.description,
              }
              : x
          )
        );
      } else await fetchCustomReportGallery();
    }
  };

  return {
    salesDetailForTransactions,
    getSalesDetailForTransactions,
    getPivotReports,
    cubeReports: getFormattedCubeReports(),
    pivotReports: getFormattedPivotReports(), // new pivot Reports
    getCustomReports,
    periodReport,
    getPeriodReports,
    getReportSettings,
    copyReport,
    copyReportPivot,
    deleteReport,
    loadingCopy: loading === LOADING_TYPES.COPY_REPORT,
    loadingDelete: loading === LOADING_TYPES.DELETE_REPORT,
    loadingSettingsFetch: loading === LOADING_TYPES.FETCH_SETTINGS,
    loadingPivotReportsFetch: loading === LOADING_TYPES.FETCH_PIVOT_REPORTS,
    loadingReportsFetch:
      loading === LOADING_TYPES.FETCH_SETTINGS ||
      loading === LOADING_TYPES.FETCH_PIVOT_REPORTS,
    loadingTxnFetch: loading === LOADING_TYPES.FETCH_TXN_DATA,
    reportSettings: getFormattedSettings(),
    loadingCubeReportsFetch: loading === LOADING_TYPES.FETCH_SETTINGS,
    addCategory,
    updateCategory,
    changeCategoryOfAReport,
    loadingUpdateCategory: loading === LOADING_TYPES.UPDATE_SETTINGS,
    getReportParams,
    reportParams,
    loadingParamsFetch: loading === LOADING_TYPES.FETCH_REPORT_PARAMS,
    getAppointmentDataForReports,
    apptDataForReports,
    loadingApptFetch: loading === LOADING_TYPES.FETCH_APPT_DATA,
    addNewPivotReport,
    updatePivotReport,
    loadingAddUpdatePivotReport:
      loading === LOADING_TYPES.ADD_NEW_PIVOT_REPORT ||
      loading === LOADING_TYPES.UPDATE_PIVOT_REPORT ||
      loading === LOADING_TYPES.UPDATE_SETTINGS,
    handleImportReport,
    addEmbedReport,
    addSubField,
    updateCustomReport,
    editPivotReport,
    customReports: reportSettings,
    overriddenSettings,
    fetchCustomReports,
    customReportGallery,
    fetchCustomReportGallery,
    makeReportPublic,
    deleteMetadata,
    getDeleteMetaData,
    updateDeleteMetaData,
    customQueryData,
    setCustomQueryData,
    getCustomQueryData,
    metabaseCards,
    getMetabaseCards,
    customDataSources,
    getCustomDataSources,
    addCustomDataSource,
    updateCustomDataSource,
    removeCustomDataSource,
    getCardDetails,
    formatDataSourceColumns,
    loadingCustomQuery,
    updatePivotReportConfiguration,
    getMetabaseDashboardParams
  };
};
